<template>
    <div>
        <v-card class="mx-0"  @click="clientFormShow = true">
            <v-card-actions>
                <v-row>
                    <v-col cols="12" v-show="userId" class="py-0">
                        Id в мессенджере {{client.id}}
                    </v-col>
                    <v-col cols="12" v-show="userId" class="py-0">
                        Имя: {{client.first_name}}
                    </v-col>
                    <v-col cols="12" v-show="userId" class="py-0">
                        Фамилия: {{client.last_name}}
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
        <client-form :dialog="clientFormShow" :client-id="userId" @close="clientFormShow = false"/>
    </div>
</template>

<script>
import ClientForm from '../client/forms/ClientForm'
import { mapGetters } from 'vuex'
export default {
    name: 'ClientCard',
    components: {
        ClientForm
    },
    props: {
        userId: Number,
        dialog: Boolean
    },
    data() {
        return {
            clientFormShow: false,
            client: {
                id: '',
                first_name: '',
                last_name: ''
            }
        }
    },
    methods: {
        loadUser() {
            if (this.userId != null) {
                let client = this.getClientByUserId(this.userId)
                if (client) { this.client = client }
            }
        }
    },
    watch: {
        userId() {
            this.loadUser()
        },
        clients() {
            this.loadUser()
        }
    },
    computed: {
        ...mapGetters({
            getClientByUserId: 'clients/getClientByUserId',
            clients: 'clients/clients'
        })
    },
    created() {
        this.loadUser()
    }
}
</script>

<style scoped>

</style>
